import Box from '@zenbusiness/zui/Box';
import { styled } from '@zenbusiness/zui/styles';

export const DisableLayer = ({ theme }) => ({
  position: 'absolute',
  left: 0,
  top: 0,
  width: '100%',
  height: '100%',
  backgroundColor: `${theme.palette.background.grey.main}`,
  opacity: 0.5,
  zIndex: 10
});

export const DisableLayerStyled = styled(Box)(DisableLayer);
